// frontend/src/components/Auth/RequireTerms.tsx
import type { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useApp } from '../../contexts/AppContext';
import TermsGate from './TermsGate';

/**
 * Renders the TermsGate instead of `children` while the signed-in user has not
 * accepted the current terms (open-access plan §3.3). Wraps every
 * authenticated route — the main app, /settings and /admin/* — so no page is
 * reachable around the gate. /privacy, /terms and /join stay outside it: the
 * gate links to the policies, and those pages must open in a new tab.
 */
const RequireTerms = ({ children }: { children: ReactNode }) => {
  const { user, signOut } = useAuth();
  const { dbUser, termsRequired, acceptTerms } = useApp();

  if (user && termsRequired) {
    return (
      <TermsGate
        email={user.email ?? ''}
        updated={Boolean(dbUser?.terms?.accepted_version)}
        onSignOut={signOut}
        onAccept={acceptTerms}
      />
    );
  }
  return <>{children}</>;
};

export default RequireTerms;
